import { defineComponent as _defineComponent } from 'vue'
import { type ComputedRef, type Ref, computed, ref, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useLinkService } from "@/composables";
import { getLtksStore } from "@/store/ltks";
import { Actions } from "@/utils/snowplow/enums";
import { createPostImpression } from "@/utils/snowplow/factory";
import { type Impression } from "@/utils/snowplow/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkPostThumbnail',
  props: {
  postId: { type: String, required: true },
  height: { type: Number, required: false, default: 100 },
  width: { type: Number, required: false, default: 80 },
  aspectRatio: { type: Number, required: false, default: 0.8 },
  position: { type: Number, required: false, default: 0 },
  hasVideo: { type: Boolean, required: false, default: false },
  referringComponent: { type: String, required: false, default: "" },
},
  setup(__props) {

const props = __props;



const store = useStore();
const amplitude = useAmplitude();
const linkService = useLinkService();

const post = computed(() => getLtksStore(store).ltks[props.postId]);

const isMediaMaximized: Ref<boolean> = ref(false);

const minimizedMedia: ComputedRef<{ url: string; srcSet: string }> = computed(() => {
  if (!post.value?.heroImage) {
    return { url: "", srcSet: "" };
  }

  const url = linkService.getImageLink({
    url: post.value?.heroImage,
    width: props.width.toString(),
    height: props.height.toString(),
    useDefaultDpr: false,
  });

  const srcSet = `${url}&dpr=1 1x, ${url}&dpr=2 2x, ${url}&dpr=3 3x`;

  return { url, srcSet };
});

const maximizedMedia: ComputedRef<{ url: string; srcSet: string; aspectRatio: number }> = computed(() => {
  if (!process.client || !post.value?.heroImage) {
    return { url: "", srcSet: "", aspectRatio: props.aspectRatio };
  }

  const aspectRatio = getLtksStore(store).ltkImageAspectRatio(props.postId) ?? props.aspectRatio;

  const url = linkService.getImageLink({
    url: post.value?.heroImage,
    width: window.innerWidth.toString(),
    height: (window.innerWidth / aspectRatio).toString(),
    useDefaultDpr: false,
  });

  const srcSet = `${url}&dpr=1 1x, ${url}&dpr=2 2x, ${url}&dpr=3 3x`;

  return { url, srcSet, aspectRatio };
});

const postImpressionPayload: ComputedRef<Impression> = computed(() =>
  createPostImpression(Actions.View, {
    id: props.postId,
    creator_id: post.value?.profileId ?? "",
    product_ids: post.value?.productIds,
    position: props.position,
  }),
);

const toggleFullscreen = () => {
  if (isMediaMaximized.value === false) {
    amplitude?.sendEvent("/post/thumbnail/expand");
  }
  isMediaMaximized.value = !isMediaMaximized.value;
};

return { __sfc: true,props, store, amplitude, linkService, post, isMediaMaximized, minimizedMedia, maximizedMedia, postImpressionPayload, toggleFullscreen }
}

})